export const addUtmSourceToUrl = (url: string) => {
    const urlObject = new URL(url)
    urlObject.searchParams.set('utm_source', 'gol')
    return urlObject.toString()
}
